import React from 'react';

function MessageOutbound(props) {
  return (
    <svg viewBox="0 0 14 27" stroke="black" {...props}>
      <g fill="none" fillRule="evenodd" strokeLinecap="round" strokeLinejoin="round">
        <path d="M1 16.708v7.042l6.5 2.708v-7.04zm12.458 0v7.042L7.5 26.458v-7.04zM1 16.708L7.23 14l6.228 2.708M7.7 1.3V10M4.4 4.6l3.3-3.3L11 4.6" />
      </g>
    </svg>
  );
}

export default MessageOutbound;
